import axios from 'axios';
import { BaseUrl } from '../../server';

export const getAllVideos = (page , limit,categoryId ) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_all_videos_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/videos`, {
            params: {
                page,
                limit,
                categoryId
            },
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_all_videos_success',
            payload: {
                videos: data.videos,
                pagination: data.pagination,
                totalVideos:data.totalVideos // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_all_videos_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};


export const getFillterVideos = (page , limit,categoryId ,titleAr,titleEn,date) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_Fillter_videos_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/videos/filter`, {
            params: {
                page,
                limit,
                categoryId,
                titleAr,
                titleEn,
                date
            },
            withCredentials: true,
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_Fillter_videos_success',
            payload: {
                videos: data.videos,
                pagination: data.pagination, // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_Fillter_videos_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};


export const getVideo = (id) => async (dispatch) => {
    try {
       
        dispatch({ type: 'get_video_request' });

        const { data } = await axios.get(`${BaseUrl}/videos/${id}`);
        console.log("data",data);
        dispatch({ type: 'get_video_success' ,payload:data.video});

    } catch (error) {
        dispatch({
            type: "get_video_error",
            payload: error.response.data.message,
          });
    }
}
export const deleteVideo = (id) => async (dispatch) => {
    try {
    
        dispatch({ type: 'delete_video_request' });

     const {data} =  await axios.delete(`${BaseUrl}/videos/${id}`);

        dispatch({ type: 'delete_video_success' ,
    payload: data.message
    });
    } catch (error) {
        dispatch({
            type: "delete_video_error",
            payload: error.response.data.message,
          });
    }
};
export const Clearvideo = () => async (dispatch) => {    
    dispatch({ type: 'clear_video' });
}